<template>
	<div>
		<!-- <p>
			Enter ingredients in the search bar to search for recipes.
		</p>
		<br />
		<p>
			Separate individual ingredients by commas (e.g. "Chicken, onions,
			mushrooms")
		</p>
		<br />
		<p>
			To exclude recipes with particular ingredients enter ingredients in the
			exclude bar (e.g. "tomato, garlic")
		</p> -->
		<img id="cover_image" src="../assets/chickenvesuvio.jpg" alt="recipe image " />
	</div>
</template>

<script>
export default {};
</script>

<style scoped>
p {
	color: #494d4e;
	font-family: 'Libre Franklin', 'Helvetica Neue', helvetica, arial, sans-serif;
}
</style>
